import * as React from 'react'
import InputWrapper from '@App/components/controls/InputWrapper'
// @ts-ignore
import { SelectAutocomplite } from 'relevant-ui'

const SelectField = (props: any) => {
  const {
    className,
    meta,
    input,
  } = props

  return (
    <InputWrapper
      meta={meta}
      {...props}
    >
      <SelectAutocomplite
        className={className}
        valid={!(meta.touched && meta.error)}
        {...props}
        {...input}
      />
    </InputWrapper>
  )
}

export default SelectField
